/* Fokusområden – gemensam interaktivitet. Vanilla JS, ingen bundling. */
(function () {
  var TONES = { good: '#7AB738', neutral: '#A2F356', watch: '#C9A227', high: '#809085', severe: '#566b57' };
  var BG = { good: '#EFF6E6', neutral: '#FBFCF7', watch: '#FFFDF4', high: '#F2F3F2', severe: '#F2F3F2' };
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function num(v, d) { var n = parseFloat(String(v || '').replace(',', '.')); return isNaN(n) ? d : n; }

  function accordion(root, qSel, itemSel) {
    all(root, qSel).forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest(itemSel);
        var open = item.classList.contains('is-open');
        all(root, itemSel).forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
  }

  function initPage(root) {
    /* Ankarnavigering */
    var targets = all(root, '.fo-nav a').map(function (a) {
      return { link: a, el: document.getElementById(a.getAttribute('href').slice(1)) };
    }).filter(function (t) { return t.el; });
    if (targets.length) {
      var spy = function () {
        var cur = targets[0];
        targets.forEach(function (t) { if (t.el.getBoundingClientRect().top <= 90) cur = t; });
        targets.forEach(function (t) { t.link.classList.toggle('is-active', t === cur); });
      };
      window.addEventListener('scroll', spy, { passive: true });
      window.addEventListener('resize', spy);
      spy();
    }

    /* Stationer */
    var items = all(root, '.fo-stations__item');
    var panels = all(root, '.fo-stations__panel [data-fo-station]');
    var nextBtn = root.querySelector('[data-fo-next]');
    var moreBtn = root.querySelector('[data-fo-more]');
    var current = 0;
    var showStation = function (i) {
      current = i;
      items.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
      all(root, '[data-fo-more-panel]').forEach(function (p) { p.hidden = true; });
      if (moreBtn) {
        moreBtn.textContent = moreBtn.dataset.labelOpen;
        moreBtn.hidden = !panels[i] || !panels[i].querySelector('[data-fo-more-panel]');
      }
    };
    items.forEach(function (b, i) { b.addEventListener('click', function () { showStation(i); }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showStation((current + 1) % items.length); });
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var p = panels[current] && panels[current].querySelector('[data-fo-more-panel]');
      if (!p) return;
      p.hidden = !p.hidden;
      moreBtn.textContent = p.hidden ? moreBtn.dataset.labelOpen : moreBtn.dataset.labelClose;
    });
    if (items.length) showStation(0);

    /* Accordions */
    accordion(root, '.fo-faq__q', '.fo-faq__item');
    accordion(root, '.fo-acc__q', '.fo-acc__item');
    accordion(root, '.fo-topic__q', '.fo-topic');

    /* Flikar i "Så kan du hjälpa" */
    var tabs = all(root, '[data-fo-tab]');
    if (tabs.length) {
      var showTab = function (key) {
        tabs.forEach(function (t) { t.classList.toggle('is-on', t.dataset.foTab === key); });
        all(root, '[data-fo-tab-lead]').forEach(function (l) { l.hidden = l.dataset.foTabLead !== key; });
        var first = true;
        all(root, '[data-fo-topic-of]').forEach(function (t) {
          var match = t.dataset.foTopicOf === key;
          t.hidden = !match;
          t.classList.toggle('is-open', match && first);
          if (match) first = false;
        });
      };
      tabs.forEach(function (t) { t.addEventListener('click', function () { showTab(t.dataset.foTab); }); });
      showTab(tabs[0].dataset.foTab);
    }

    /* Checklista */
    var check = root.querySelector('[data-fo-check]');
    if (check) {
      var cchips = all(check, '.fo-check-chip');
      var cnote = check.querySelector('[data-fo-check-note]');
      var cupdate = function () {
        var on = all(check, '.fo-check-chip.is-on').length;
        var share = on / (cchips.length || 1);
        check.querySelector('[data-fo-check-count]').textContent = on;
        check.querySelector('[data-fo-check-fill]').style.width = Math.round(share * 100) + '%';
        if (cnote) cnote.textContent = on === 0 ? cnote.dataset.n0 : share < 0.38 ? cnote.dataset.n1 : share < 0.75 ? cnote.dataset.n2 : cnote.dataset.n3;
      };
      cchips.forEach(function (c) { c.addEventListener('click', function () { c.classList.toggle('is-on'); cupdate(); }); });
      cupdate();
    }

    /* Komplement */
    var needTabs = all(root, '.fo-need-tab');
    var needPanels = all(root, '[data-fo-need-panel]');
    var showNeed = function (i) {
      needTabs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
      needPanels.forEach(function (p, n) { p.hidden = n !== i; });
    };
    needTabs.forEach(function (t, i) { t.addEventListener('click', function () { showNeed(i); }); });
    if (needTabs.length) showNeed(0);

    all(root, '[data-fo-module]').forEach(initModule);
    initIndex(root);
  }

  function initModule(mod) {
    var kind = mod.dataset.foModule;
    var zones = all(mod, '[data-fo-zones] span').map(function (z) {
      var raw = z.dataset.max || '';
      var aOnly = /^A\s*<=/i.test(raw);
      return {
        aOnly: aOnly, max: num(aOnly ? raw.replace(/^A\s*<=/i, '') : raw, Infinity),
        name: z.dataset.name, title: z.dataset.title || z.dataset.name, tone: z.dataset.tone || 'neutral', text: z.dataset.text,
        ex: (z.dataset.ex || '').split(';').map(function (s) { return s.trim(); }).filter(Boolean)
      };
    });
    var q = function (sel) { return mod.querySelector(sel); };
    var zoneText = q('[data-fo-zone-text]'), zoneName = q('[data-fo-zone-name]'),
        zoneLabel = q('[data-fo-zone-label]'), zoneBox = q('[data-fo-zone-box]'), zoneEx = q('[data-fo-zone-ex]');

    var paint = function (value, aValue) {
      if (!zones.length) return null;
      var z = null, i;
      for (i = 0; i < zones.length; i++) if (zones[i].aOnly && aValue <= zones[i].max) { z = zones[i]; break; }
      if (!z) for (i = 0; i < zones.length; i++) if (!zones[i].aOnly && value <= zones[i].max) { z = zones[i]; break; }
      if (!z) z = zones[zones.length - 1];
      if (zoneText) zoneText.textContent = z.text;
      if (zoneText && !zoneBox) zoneText.className = 'fo-module__verdict is-' + z.tone;
      if (zoneName) zoneName.textContent = z.title;
      if (zoneLabel) zoneLabel.textContent = z.name;
      if (zoneBox) zoneBox.style.background = BG[z.tone] || BG.neutral;
      if (zoneEx) zoneEx.innerHTML = z.ex.map(function (e) { return '<li>' + e.replace(/</g, '&lt;') + '</li>'; }).join('');
      return z;
    };
    var empty = function () {
      if (zoneText) { zoneText.textContent = mod.dataset.foEmpty; zoneText.className = 'fo-module__verdict'; }
    };

    if (kind === 'slider' || kind === 'fuel') {
      var range = q('[data-fo-slider]'), out = q('[data-fo-slider-value]'), fill = q('[data-fo-slider-fill]');
      var min = num(range.min, 0), max = num(range.max, 10);
      var fatBar = q('[data-fo-fat-bar]'), carbBar = q('[data-fo-carb-bar]');
      var fs = num(mod.dataset.fatStart, 70), step = num(mod.dataset.fatStep, 6.5);
      var render = function () {
        var v = num(range.value, 0);
        if (out) out.textContent = v;
        var z = paint(v, v);
        if (fill) {
          fill.style.width = Math.round(((v - min) / (max - min || 1)) * 100) + '%';
          fill.style.background = z ? TONES[z.tone] || TONES.neutral : TONES.good;
        }
        if (fatBar && carbBar) {
          var fat = Math.max(0, Math.min(100, Math.round(fs - v * step)));
          fatBar.style.width = fat + '%';
          carbBar.style.width = (100 - fat) + '%';
          fatBar.textContent = mod.dataset.aLabel + ' ' + fat + ' %';
          carbBar.textContent = mod.dataset.bLabel + ' ' + (100 - fat) + ' %';
        }
      };
      range.addEventListener('input', render);
      render();
    }

    if (kind === 'dual_slider') {
      var a = q('[data-fo-a]'), b = q('[data-fo-b]');
      var levels = (mod.dataset.foLevels || '').split(',').map(function (s) { return s.trim(); });
      var render2 = function () {
        var av = num(a.value, 0), bv = num(b.value, 0);
        q('[data-fo-a-text]').textContent = levels[av] || '';
        q('[data-fo-b-text]').textContent = levels[bv] || '';
        q('[data-fo-b-fill]').style.width = (bv * 10) + '%';
        q('[data-fo-a-mark]').style.left = 'calc(' + (av * 10) + '% - 2px)';
        paint(av - bv, av);
      };
      a.addEventListener('input', render2);
      b.addEventListener('input', render2);
      render2();
    }

    if (kind === 'dual_chips') {
      var render3 = function () {
        var an = all(mod, '[data-fo-chip-a].is-on').length, bn = all(mod, '[data-fo-chip-b].is-on').length, tot = an + bn;
        q('[data-fo-a-count]').textContent = an;
        q('[data-fo-b-count]').textContent = bn;
        q('[data-fo-a-bar]').style.width = (tot ? Math.round((an / tot) * 100) : 0) + '%';
        q('[data-fo-b-bar]').style.width = (tot ? Math.round((bn / tot) * 100) : 0) + '%';
        if (tot === 0) empty(); else paint(an - bn, an);
      };
      all(mod, '.fo-dual-chip').forEach(function (c) { c.addEventListener('click', function () { c.classList.toggle('is-on'); render3(); }); });
      q('[data-fo-reset]').addEventListener('click', function () { all(mod, '.fo-dual-chip').forEach(function (c) { c.classList.remove('is-on'); }); render3(); });
      render3();
    }

    if (kind === 'pick_count') {
      var picks = all(mod, '[data-fo-pick]');
      var render4 = function () {
        var on = all(mod, '[data-fo-pick].is-on').length;
        q('[data-fo-pick-count]').textContent = on;
        q('[data-fo-pick-fill]').style.width = Math.round((on / (picks.length || 1)) * 100) + '%';
        paint(on, on);
      };
      picks.forEach(function (c) { c.addEventListener('click', function () { c.classList.toggle('is-on'); render4(); }); });
      q('[data-fo-reset]').addEventListener('click', function () { picks.forEach(function (c) { c.classList.remove('is-on'); }); render4(); });
      render4();
    }

    if (kind === 'protein') {
      var kg = q('[data-fo-slider]');
      var mealBtns = all(mod, '[data-fo-meals]');
      var on = mealBtns.filter(function (x) { return x.classList.contains('is-on'); })[0] || mealBtns[0];
      var meals = on ? num(on.dataset.foMeals, 4) : 4;
      var d = mod.dataset;
      var fill5 = function (t, o) { return (t || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); };
      var render5 = function () {
        var w = num(kg.value, 80);
        var lo = Math.round(w * num(d.dayLo, 1.6)), hi = Math.round(w * num(d.dayHi, 2));
        var mlo = Math.round(w * num(d.mealLo, 0.3)), mhi = Math.round(w * num(d.mealHi, 0.4));
        q('[data-fo-slider-value]').textContent = w;
        q('[data-fo-day]').textContent = lo + '–' + hi + ' g';
        q('[data-fo-meal]').textContent = mlo + '–' + mhi + ' g';
        q('[data-fo-meal-n]').textContent = meals + ' ' + (mealBtns[0] ? mealBtns[0].textContent.replace(/^\d+\s*/, '') : '');
        var bars = '';
        for (var i = 0; i < meals; i++) bars += '<span></span>';
        q('[data-fo-meal-bars]').innerHTML = bars;
        var o = { n: meals, lo: mlo * meals, hi: mhi * meals, mlo: mlo, mhi: mhi };
        q('[data-fo-meal-note]').textContent = mhi * meals < lo ? fill5(d.noteShort, o) : fill5(d.noteOk, o);
      };
      mealBtns.forEach(function (bt) {
        bt.addEventListener('click', function () {
          meals = num(bt.dataset.foMeals, 4);
          mealBtns.forEach(function (x) { x.classList.toggle('is-on', x === bt); });
          render5();
        });
      });
      kg.addEventListener('input', render5);
      render5();
    }
  }

  /* Översiktssidan – filtrera korten */
  function initIndex(root) {
    var grid = root.querySelector('[data-fo-index-grid]');
    if (!grid) return;
    var btns = all(root, '[data-fo-filter]');
    var cards = all(grid, '.fo-area');
    var emptyEl = root.querySelector('[data-fo-index-empty]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.foFilter, shown = 0;
        btns.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        cards.forEach(function (c) {
          var match = !tag || (c.dataset.foTags || '').indexOf('|' + tag) > -1;
          c.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (emptyEl) emptyEl.hidden = shown > 0;
      });
    });
  }

  function boot() {
    all(document, '[data-fo-root]').forEach(function (root) {
      if (root.dataset.foReady === '1') return;
      root.dataset.foReady = '1';
      initPage(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
